import React, { memo, useMemo } from "react";
import { isEmpty } from "@swiggy-private/js-utils";
import { SpriteIconWeb } from "@swiggy-private/dls-web-icons/dist/SpriteIconWeb";
import { useTheme } from "styled-components";
import { BackButtonContainer, BackButtonIcon, BackButtonTitle } from "./styles";
import { IBackButtonProps } from "./types";

const BackButton = ({
    onClick,
    hasScrolledBackground = false,
    position = "absolute",
    top,
    left,
    zIndex = 10,
    accessibilityLabel = "back-button",
    title,
}: IBackButtonProps) => {
    const { colorMode } = useTheme();

    const backIconColor = useMemo(() => {
        const isDark = colorMode === "dark";

        return !isDark && !hasScrolledBackground
            ? "text_inverse_Highest_Emphasis"
            : "text_Highest_Emphasis";
    }, [colorMode, hasScrolledBackground]);

    return (
        <BackButtonContainer
            hasScrolledBackground={hasScrolledBackground}
            position={position}
            top={top}
            left={left}
            zIndex={zIndex}
        >
            <BackButtonIcon
                onClick={onClick}
                role="button"
                aria-label={accessibilityLabel}
                tabIndex={0}
            >
                <SpriteIconWeb iconName="arrowBack20" fillColor={backIconColor} />
            </BackButtonIcon>
            {!isEmpty(title) && hasScrolledBackground && (
                <BackButtonTitle variant="V2.body1.neutral.bold" color="text_Highest_Emphasis">
                    {title}
                </BackButtonTitle>
            )}
        </BackButtonContainer>
    );
};

export default memo(BackButton);
